import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PageTopComponent} from './page-top.component';
import {BurgerMenuModule} from '../burger-menu/burger-menu.module';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ProfileTopModule} from '../profile-top/profile-top.module';



@NgModule({
  declarations: [
    PageTopComponent,
  ],
  exports: [
    PageTopComponent,
  ],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    BurgerMenuModule,
    ProfileTopModule,
  ]
})
export class PageTopModule { }
